export type CustomerModuleAction =
  | 'pdf'
  | 'cancelledInvoicePdf'
  | 'markAsRepaired'
  | 'edit'
  | 'view'
  | 'addSignature'
  | 'updateSignature'
  | 'delete'
  | 'toMachinery'
  | 'requestExpressRepair'
  | 'withdrawExpressRepairRequest'
  | 'showComments'

export const actionButtonIconPresets = {
  pdf: 'material-symbols:description-outline-rounded',
  cancelledInvoicePdf: 'material-symbols:description-outline-rounded',
  markAsRepaired: 'material-symbols:check-circle-outline-rounded',
  edit: 'material-symbols:edit-outline-rounded',
  view: 'material-symbols:visibility-outline-rounded',
  addSignature: 'material-symbols:signature',
  updateSignature: 'material-symbols:edit-outline-rounded',
  delete: 'material-symbols:delete-outline-rounded',
  toMachinery: 'material-symbols:visibility-outline-rounded',
  requestExpressRepair: 'material-symbols:home-repair-service-outline-rounded',
  withdrawExpressRepairRequest: 'material-symbols:reset-wrench-outline-rounded',
  showComments: 'material-symbols:forum-outline-rounded',
} as const satisfies Record<CustomerModuleAction, string>
